import register from 'ShopUiBundle/modules/app/registry';
import './style.scss';

// tslint:disable-next-line
register('flash-message', () => import(/* webpackMode: "lazy" */'./flash-message'));
